import { useContext } from "react";
import { InboxContext } from "./InboxContext";

export const useInboxContext = () => {
  const context = useContext(InboxContext);
  if (!context)
    throw new Error("useInboxContext must be used within InboxProvider");
  return context;
};
